import {
  Typography,
  makeStyles,
  AppBar,
  Tab,
  Tabs,
  Box,
  Grid,
  useTheme,
} from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import RepositoryMain from "./repositoryTabs/repositoryMain";
import PermissionMapping from "./repositoryTabs/permissionList";
import RolesMapping from "./repositoryTabs/rolesMapping";
import PractitionerTable from "../practitionerMaster/practitionertable";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.table,

    "& .App1-MuiTab-textColorPrimary": {
      "&.Mui-selected": {
        color: "#0071F2",
      },
    },
    "&.App1-MuiPaper-elevation4": {
      shadow: "none",
    },
    "& .App1-MuiTab-root": {
      [theme.breakpoints.up("xs")]: {
        minWidth: "inherit !important",
      },
    },
    "& .App1-MuiAppBar-root": {
      width: "80%",
    },
  },
  MuiTab: {
    root: {
      minWidth: 0,
      "@media (min-width: 0px)": {
        minWidth: 0,
      },
    },
  },
  box: {
    // padding: "24px 12px",
    // paddingBottom: "43px",
    backgroundColor: theme.palette.background.common,
    // height: "100vh",
    height: "100%",
    // paddingTop: "14px",
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={classes.box}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Repository(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [listData, setListData] = React.useState([]);
  React.useEffect(() => {
    const baseFun = async () => {
      // let permission = await checkWithCasbin(["userManagement"]);
      // function onlyUnique(value, index, self) {
      //   return self.indexOf(value) === index;
      // }
      // let arr = [];
      // var unique = [...permission.read, ...permission.write].filter(onlyUnique);
      var unique = [
        "repository",
        "permissionList",
        "roles",
        // "rolesMapping",
        "person",
        "users",
      ];

      setListData(unique);
    };
    baseFun();
    if (props?.location?.state?.index) {
      setValue(props?.location?.state?.index ?? 0);
    }
  }, []);

  React.useEffect(() => {
    if (props?.location?.state) {
      setValue(props?.location?.state?.index ?? 0);
    }
    // eslint-disable-next-line
  }, [props?.location?.state?.index]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Grid container spacing={0}>
      <Grid item md={12}>
        <div className={classes.root}>
          <div
            style={{
              // display: "flex",
              background: theme.palette.background.table,
            }}
          >
            <div
              style={{
                paddingTop: "14px",
                paddingLeft: "25px",
                fontFamily: "poppinsemibold",
                fontSize: "14px",
                // width: "200px",
                whiteSpace: "nowrap",
              }}
            >
              Permission Management
            </div>
            <AppBar
              position="static"
              color="default"
              style={{ boxShadow: "none", zIndex: "auto" }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className={classes.root}
              >
                {listData.indexOf("repository") > -1 && (
                  <Tab
                    style={{
                      fontSize: "12px",
                      textTransform: "unset",
                      fontFamily: "poppinsemibold",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      marginLeft: "20px",
                    }}
                    className={classes.color}
                    label="Repository"
                    {...a11yProps(1)}
                  />
                )}
                {listData.indexOf("permissionList") > -1 && (
                  <Tab
                    style={{
                      fontSize: "12px",
                      textTransform: "unset",
                      fontFamily: "poppinsemibold",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      marginLeft: "20px",
                    }}
                    label="Permission List"
                    {...a11yProps(2)}
                  />
                )}
                {listData.indexOf("roles") > -1 && (
                  <Tab
                    style={{
                      fontSize: "12px",
                      textTransform: "unset",
                      fontFamily: "poppinsemibold",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      marginLeft: "20px",
                    }}
                    label="Roles"
                    {...a11yProps(4)}
                  />
                )}
                {listData.indexOf("rolesMapping") > -1 && (
                  <Tab
                    style={{
                      fontSize: "12px",
                      textTransform: "unset",
                      fontFamily: "poppinsemibold",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      marginLeft: "20px",
                    }}
                    label="Role Mapping"
                    {...a11yProps(3)}
                  />
                )}
                {listData.indexOf("person") > -1 && (
                  <Tab
                    style={{
                      fontSize: "12px",
                      textTransform: "unset",
                      fontFamily: "poppinsemibold",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      marginLeft: "20px",
                    }}
                    label="Person"
                    {...a11yProps(5)}
                  />
                )}
                {/*
                {listData.indexOf("users") > -1 && (
                  <Tab
                    style={{
                      fontSize: "12px",
                      textTransform: "unset",
                      fontFamily: "poppinsemibold",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      marginLeft: "20px",
                    }}
                    label="Users"
                    {...a11yProps(6)}
                  />
                )} */}
              </Tabs>
            </AppBar>
          </div>
          <TabPanel value={value} index={0} style={{ padding: "0px" }}>
            <div
              style={{ borderRadius: "10px", width: "100%", padding: "0px" }}
            >
              <RepositoryMain />
            </div>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <div
              style={{ borderRadius: "10px", width: "100%", padding: "0px" }}
            >
              <PermissionMapping />
            </div>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <div style={{ borderRadius: "10px", width: "99%", padding: "0px" }}>
              {/* <Roles /> */}
              {/* <PractitionerRoleTable
                parent_id={"PractitionerRole"}
                type={"PRACTROLE"}
                header={"Practitioner Role"}
              /> */}
              {/* <Roles /> */}
              <RolesMapping />
            </div>
          </TabPanel>
          {/* <TabPanel value={value} index={3}>
            <div
              style={{ borderRadius: "10px", width: "100%", padding: "0px" }}
            >
              <RolesMapping />
            </div>
          </TabPanel> */}
          <TabPanel value={value} index={3}>
            <div style={{ borderRadius: "10px", width: "99%", padding: "0px" }}>
              <PractitionerTable parent_id={"Practitioner"} />
            </div>
          </TabPanel>
          {/*<TabPanel value={value} index={5}>
            <div style={{ borderRadius: "10px", width: "99%", padding: "0px" }}>
              <Users />
            </div>
          </TabPanel> */}
        </div>
      </Grid>
    </Grid>
  );
}

export default Repository;
